import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'

export function buildRenamePreviewPaths(
  remotePaths: string[],
  plan: RenamePlan
): Array<{ sourcePath: string; displayPath: string }> {
  const paths = new Map<string, { sourcePath: string; displayPath: string }>()

  for (const remotePath of remotePaths) {
    paths.set(remotePath, {
      sourcePath: remotePath,
      displayPath: remotePath
    })
  }

  for (const rename of plan.customCells) {
    paths.set(rename.oldPath, {
      sourcePath: rename.oldPath,
      displayPath: rename.newPath
    })
    paths.set(rename.columnsPath, {
      sourcePath: rename.columnsPath,
      displayPath: rename.columnsPath
    })
  }

  return Array.from(paths.values()).sort((a, b) => a.displayPath.localeCompare(b.displayPath))
}
